import React from 'react';
import './BioSection.css';
import PropTypes from 'prop-types';

const BioSection = ({ title, items }) => {
  return (
    <div>
      <p className="bio">
        {title}
        <span className="bio-table">
          <ul>
            {items.map((item, index) => (
              <li key={index}>
                <img src={item.imgSrc} alt={`${item.title} icon`} />
                <div className="education-info">
                  <div className="title">{item.title}</div>
                  <div className="institution">{item.institution}</div>
                </div>
                <span className="date">{item.date}</span>
                <span className="hover-text">{item.hoverText}</span>
              </li>
            ))}
          </ul>
        </span>
      </p>
    </div>
  );
};

BioSection.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default BioSection;
